import { render, staticRenderFns } from "./TagName.vue?vue&type=template&id=2fe29b14&scoped=true&"
import script from "./TagName.vue?vue&type=script&lang=js&"
export * from "./TagName.vue?vue&type=script&lang=js&"
import style0 from "./TagName.vue?vue&type=style&index=0&id=2fe29b14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe29b14",
  null
  
)

export default component.exports